// const baseUrl = "http://127.0.0.1:8000";
const baseUrl = "https://decorapi.ahnaeem.site";

const loginUrl = `${baseUrl}/api/login`

//category
const categoryUrl = `${baseUrl}/api/admin/categorys`

//posts
const postUrl = `${baseUrl}/api/admin/posts`

//setting
const settingUrl =`${baseUrl}/api/admin/setting`

//setting
const commentsUrl =`${baseUrl}/api/front/comments`
const commentStatusUpdateUrl =`${baseUrl}/api/front/comments-status`



export {
  baseUrl,

  loginUrl,

  categoryUrl,

  postUrl,
  settingUrl,
  commentsUrl,
  commentStatusUpdateUrl
};
